import { render, staticRenderFns } from "./AdminPrizePoolSection.vue?vue&type=template&id=4dc4b664&scoped=true"
import script from "./AdminPrizePoolSection.vue?vue&type=script&lang=js"
export * from "./AdminPrizePoolSection.vue?vue&type=script&lang=js"
import style0 from "./AdminPrizePoolSection.vue?vue&type=style&index=0&id=4dc4b664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4b664",
  null
  
)

export default component.exports